export default __webpack_public_path__ + "static/media/VirtualTwilight2.b9d16a26.jpg";